//引入
import cmpTitle from '@cmp/cmp-title'
import cmpBread from '@cmp/bread'
import cmpBanner from '@cmp/cmp-banner'
import cmpMyPagination from '@cmp/my-pagination'

function plugins(Vue) {
  //注册
  Vue.component('cmpTitle', cmpTitle) //第一个参数:组件名称,第二个参数:要注册的组件
  Vue.component('cmpBread', cmpBread)
  Vue.component('cmpBanner', cmpBanner)
  Vue.component('cmpMyPagination', cmpMyPagination)
}
export default plugins